import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "ListNumber"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M12 16.5H22.5V18H12V16.5ZM12 6H22.5V7.5H12V6ZM6 9V3H4.5V3.75H3V5.25H4.5V9H3V10.5H7.5V9H6ZM7.5 21H3V18C3 17.1716 3.67157 16.5 4.5 16.5H6V15H3V13.5H6C6.82843 13.5 7.5 14.1716 7.5 15V16.5C7.5 17.3284 6.82843 18 6 18H4.5V19.5H7.5V21Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/ListNumber.vue"]]);
